// extracted by mini-css-extract-plugin
export default {"MainCont":"Oven_MainCont__kT95X","LeftCont":"Oven_LeftCont__m15Ah","RightCont":"Oven_RightCont__SywtX"};